export const ENGAGEMENT_TYPES = {
  NOTE: 'NOTE'
};
const NOTE_TYPE_ID = '0-46';
export const engagementTypeIdToTypeMap = {
  [NOTE_TYPE_ID]: ENGAGEMENT_TYPES.NOTE
};
export const ENGAGEMENT_TYPE_IDS = Object.keys(engagementTypeIdToTypeMap);